import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

export interface ScopeNavProps {
  onPrev: () => void;
  onNext: () => void;
  prevLabel?: string;
  nextLabel?: string;
  className?: string;
}

export function ScopeNav({
  onPrev,
  onNext,
  prevLabel = "Vorige",
  nextLabel = "Volgende",
  className,
}: ScopeNavProps) {
  const baseBtn = cn(
    "inline-flex size-6 items-center justify-center rounded-3 border border-line bg-surface text-ink-700",
    "hover:bg-surface-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-p-600 focus-visible:ring-offset-1",
  );
  return (
    <div className={cn("inline-flex items-center gap-1", className)}>
      <button type="button" aria-label={prevLabel} onClick={onPrev} className={baseBtn}>
        <ChevronLeft size={14} />
      </button>
      <button type="button" aria-label={nextLabel} onClick={onNext} className={baseBtn}>
        <ChevronRight size={14} />
      </button>
    </div>
  );
}
